import { render, staticRenderFns } from "./ModelPublishFiles.vue?vue&type=template&id=4ed69641&"
import script from "./ModelPublishFiles.vue?vue&type=script&lang=ts&"
export * from "./ModelPublishFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ed69641')) {
      api.createRecord('4ed69641', component.options)
    } else {
      api.reload('4ed69641', component.options)
    }
    module.hot.accept("./ModelPublishFiles.vue?vue&type=template&id=4ed69641&", function () {
      api.rerender('4ed69641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modelPublish/ModelPublishFiles.vue"
export default component.exports